import * as React from 'react';

import { cn } from '../../lib/utils';

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'prefix' | 'suffix'> {
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  affixSpacing?: 'default' | 'compact';
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', prefix, suffix, affixSpacing = 'default', ...props }, ref) => {
    const hasAffixes = prefix != null || suffix != null;
    const affixPaddingClass = affixSpacing === 'compact' ? 'px-2' : 'px-3';
    const inputPaddingClass = affixSpacing === 'compact' ? 'px-2 py-2' : 'px-3 py-2';

    if (hasAffixes) {
      return (
        <div
          className={cn(
            'flex w-full items-center rounded-md border border-input bg-background text-sm ring-offset-background focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2',
            props.disabled && 'opacity-50',
            className
          )}
        >
          {prefix ? <span className={cn('select-none text-muted-foreground', affixPaddingClass)}>{prefix}</span> : null}
          <input
            type={type}
            className={cn(
              'flex-1 bg-transparent text-sm outline-none placeholder:text-muted-foreground',
              inputPaddingClass,
            )}
            ref={ref}
            {...props}
          />
          {suffix ? <span className={cn('select-none text-muted-foreground', affixPaddingClass)}>{suffix}</span> : null}
        </div>
      );
    }

    return (
      <input
        type={type}
        className={cn(
          'flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
